import React from 'react'
import Markdown from "react-markdown"

import {Link} from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { Chart } from "react-google-charts";
import {format} from 'date-fns';

import { getPageUrl } from '../lib/helpers'

import Container from '../components/container'
import Offer from '../components/offer'

import * as styles from './dynamic-zone-component.module.css'


function DynamicZoneComponent ({component, index = "", anchor_id=null}) {
  
  if (component.__typename == "STRAPI_ComponentContentListTopN"){

    if (component.is_ordered == false){
      index = ""
    }

    return (
        <>
          <div><Container>
              {component.page && 
                <h2 className={styles.listTitle} id={anchor_id}>{index}{component.title}</h2>
              }
              { !component.page && 
                <h2 className={styles.listTitle} id={anchor_id}>{index}{component.title}</h2>
              }
              {component.introduction && 
                <Markdown children={component.introduction} skipHtml={true} />
              }
          </Container></div>
              {
                // main image if no children
                component.section_image &&
                <div className={styles.sectionImage}>
                    <GatsbyImage image={getImage(component?.section_image?.imageFile)} alt={component.section_image.alternativeText ? component.section_image.alternativeText : component.title } />
                    <div className={styles.sectionImageCopyright}>{component.section_image.caption}</div>
                </div>
                }
          <div><Container>
            { component.offers && 
              component.offers.map(offer => (
                <span key={offer.id}><Offer offer={offer}></Offer></span>
              ))
            }
            <Markdown children={component.description} allowDangerousHtml />  
            {component.page && 
            <><b>MORE:</b> <Link to={getPageUrl(component.page)} className={styles.subheading}>{component.page.title}</Link></>
            }
          </Container></div>
        </>
      )
  }
  // DATA - PLOT AND TABLE
  if (component.__typename == "STRAPI_ComponentDataTabularData"){
    const data = component.data.to_plot

    const options = {
      title: "Plot of "+component.title,
      vAxis: { title: "Count"},
      legend: "bottom",
      chartArea: {
        left:50,
        top:20,
        right:15,
        bottom:50
      }
    };

    // highlight the selected in the table
    const chartEvents = [
      {
        eventName: "select",
        callback({ chartWrapper }) {
          console.log("Selected ", chartWrapper.getChart().getSelection());
        }
      }
    ];
    
    var alignment = ["tdLeft", "tdLeft", "tdLeft", "tdLeft", "tdLeft", "tdLeft"]
    if ("column_alignment" in component.data){
      alignment = component.data.column_alignment
    }

    return (
      <>
      <div><Container>
        <h2 className={styles.listTitle}>{component.title}</h2>
        <div>{component.description}</div>
      </Container></div>
      <div className={styles.sectionPlot}>
        <Chart
          chartType="LineChart"
          data={data}
          options={options}
          width="100%"
          height="400px"
          legendToggle
          chartEvents={chartEvents}
        />
      </div>
      <div><Container>
        <div>
          <Markdown children={component.body} skipHtml={true} />
        </div>
        <table className={styles.dataTable}>
          <caption>{component.title}</caption>
          <tr className={styles.dataTableHeader}>
          {component.data && component.data.column_headers && component.data.column_headers.map((header,index_nodes) => (
            <th>
            {header}
            </th>
          ))}
          </tr>
          {component.data && component.data.rows && component.data.rows.map((row,row_nodes) => (
            <tr className={styles.dataTableRow} key={"row_"+row_nodes}>
            
            {row.map((cell,cell_nodes) => (
              <td className={styles[alignment[cell_nodes]]} key={"cell_"+row_nodes+"_"+cell_nodes}>
                {cell}
              </td>
            ))}
            </tr>
          ))}
        </table>
        <div className={styles.dataTableFooter}>Data last updated on {format( Date.parse(component.data_updated_at), "MMMM do, yyyy")}. {component.footnote}</div>
      </Container></div>
      </>
    )
  }
  if (component.__typename == "STRAPI_ComponentContentQuestionAndAnswer"){
    return (
      <div><Container>
        <div itemScope="" itemProp="mainEntity" itemType="https://schema.org/Question">
          <h2 itemProp="name" className={styles.listTitle} id={anchor_id}>{component.Question}</h2>
          <div itemScope="" itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <div itemProp="text">
              <Markdown children={component.answer} allowDangerousHtml /> 
            </div>
          </div>
        </div>
      </Container></div>
    )
  }
  if (component.__typename == "STRAPI_ComponentContentEmbeddedHtml"){
    return (
        <div className={styles.sectionEmbeded} dangerouslySetInnerHTML={{__html: component.raw_html }} />
    )
  }
  return (
    <>
        <h2>{component.__typename}</h2>
    </>
  )
}

DynamicZoneComponent.defaultProps = {
    props: {},
  }

export default DynamicZoneComponent
